import { render } from "./ProjectModal.vue?vue&type=template&id=79fda09b&ts=true"
import script from "./ProjectModal.vue?vue&type=script&lang=ts"
export * from "./ProjectModal.vue?vue&type=script&lang=ts"

import "./ProjectModal.vue?vue&type=style&index=0&id=79fda09b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__